import { useState } from "react";

export default function SubscribeBand() {
  const [email, setEmail] = useState("");
  const [notice, setNotice] = useState("");

  const handleSubscribe = () => {
    if (!email.trim() || !email.includes("@")) {
      setNotice("请输入有效的邮箱地址");
      return;
    }
    setNotice("订阅成功，我们会在每周更新后提醒你");
    setEmail("");
  };

  return (
    <section className="px-4 md:px-8 py-12">
      <div className="relative rounded-lg overflow-hidden bg-secondary-700 text-background-50">
        <div className="absolute -right-10 -top-16 w-64 h-64 rounded-full bg-accent-500/25" />
        <div className="absolute -left-16 bottom-0 w-56 h-56 rounded-full bg-primary-500/25" />
        <div className="relative px-6 md:px-12 py-10 md:py-14 flex flex-col lg:flex-row lg:items-center gap-8">
          <div className="flex-1">
            <p className="text-xs tracking-[0.3em] text-accent-200 font-label mb-3">NEWSLETTER</p>
            <h2 className="font-heading text-xl md:text-3xl font-black leading-snug">
              每周一封，只推值得看的
            </h2>
            <p className="mt-3 text-sm text-background-100/85 max-w-xl leading-relaxed">
              订阅后，我们会把当周的精选合集、热门推荐与话题清单整理成一封简报，直接送到你的邮箱。
            </p>
          </div>
          <div className="lg:w-[420px] shrink-0">
            <div className="flex flex-col sm:flex-row gap-3">
              <div className="relative flex-1">
                <i className="ri-mail-line absolute left-3 top-1/2 -translate-y-1/2 text-secondary-400 text-base" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入你的邮箱地址"
                  className="w-full h-11 pl-10 pr-3 rounded-md border border-background-100/25 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:ring-2 focus:ring-accent-300"
                />
              </div>
              <button
                type="button"
                onClick={handleSubscribe}
                className="h-11 px-6 rounded-md bg-accent-500 text-accent-950 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-accent-400"
              >
                免费订阅
              </button>
            </div>
            {notice ? (
              <p className="mt-3 text-xs text-background-50/90 inline-flex items-center gap-1.5">
                <i className="ri-information-line" /> {notice}
              </p>
            ) : (
              <p className="mt-3 text-xs text-background-100/70">我们不会向第三方分享你的邮箱。</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}